{
  "title": "Acid Splash",
  "source": "Player's Handbook",
  "levelAndSchool": "Conjuration cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "You hurl a bubble of acid. Choose one creature you can see within range, or choose two creatures you can see within range that are within 5 feet of each other. A target must succeed on a Dexterity saving throw or take 1d6 acid damage.",
    "At Higher Levels. This spell’s damage increases by 1d6 when you reach 5th level (2d6), 11th level (3d6), and 17th level (4d6)."
  ],
  "spellLists": ["artificer", "eldritch-knight", "arcane-trickster", "sorcerer", "wizard"]
}
